// extracted by mini-css-extract-plugin
export default {"amount":"DisplayPrice_amount__DX7fE","onSale":"DisplayPrice_onSale__hWZbF","salePrice":"DisplayPrice_salePrice__2VjET"};